/**
 * phase-ui-review-F14 — ONE definition of "is this prompt active", for every
 * surface that lists, filters, counts, toggles, or displays prompt activation.
 *
 * ## The defect this closes
 *
 * A PromptLibrary row carries TWO activation columns:
 *   - `IsActive` (boolean) — the Phase 8.3 Layer 2 column.
 *   - `Status` ('active' | 'draft') — the older Phase 5.X column.
 *
 * The runtime classifier (`src/services/claude/promptLibraryClassifier.ts`)
 * filters on `IsActive = true` — so `IsActive` is the ONLY column that decides
 * whether a prompt actually runs. But the Prompt Library UI read `Status`
 * everywhere (list badge, Status filter, Set-All-Active count, toggle label),
 * and the toggle/bulk-activate/duplicate backend writes touched only `Status`.
 * Net effect: an admin could "activate" a prompt in the UI (flipping `Status`)
 * while the classifier — reading the untouched `IsActive` — kept ignoring it,
 * and vice-versa. Two forked copies of one rule, silently diverging.
 *
 * Fix (per CLAUDE.md "one evaluator per rule, consumed everywhere"): the UI
 * reads activation through THIS function, which trusts the runtime-authoritative
 * `IsActive`; the backend write paths now keep `Status` in sync with `IsActive`
 * for those activation actions. Older rows may still have a stale Status mirror;
 * it is never used to decide whether a prompt runs.
 */
export function isPromptActive(entry: { readonly IsActive: boolean }): boolean {
  return entry.IsActive === true;
}
